import * as T from '../types';

const setIsPaymentInProgress = (isPaymentInProgress) => {
  return { type: T.SET_IS_PAYMENT_IN_PROGRESS, isPaymentInProgress };
};

export default setIsPaymentInProgress;
